import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  useExportSocietiesQuery,
  useGetAllSocietiesQuery,
  useLazyExportSocietiesQuery,
} from "../../redux/societyApi";
import { ReactSVG } from "react-svg";
import { useDebounce } from "use-debounce";
import LOPLink from "./LOPLink";
import { HiDotsVertical } from "react-icons/hi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { FiX } from "react-icons/fi";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { showErrorToast } from "../../utils/Utils";

const HousingScocieties = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);
  const [viewFile, setViewFile] = useState(null);
  const [open, setOpen] = useState(false);
  const { data, error, isLoading, isFetching } = useGetAllSocietiesQuery({
    page,
    search: debouncedSearch,
  });

  const getBgColor = (status) => {
    if (status === "approved") return "bg-[#DEE9E4]";
    if (status === "unapproved" || status === "underProcess")
      return "bg-[#DDEBF7]";
    return "bg-[#F1D1CE]";
  };
  const gettextColor = (status) => {
    if (status === "approved") return "text-[#00643B]";
    if (status === "unapproved" || status === "underProcess")
      return "text-[#008CFF]";
    return "text-[#D80000]";
  };

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  return (
    <>
      <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
        <div className="flex justify-between items-center">
          <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
            Housing Societies
          </p>
          <div className="flex  items-center">
            {/* <button className="w-[12rem] bg-[#DEDEDE] text-[#717171] flex justify-between items-center p-3 rounded-xl font-medium">
            Sort By <IoIosArrowDown />
          </button> */}
            <NavLink
              to={"/housing-societies/add-housing-societies"}
              className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
            >
              + Add More
            </NavLink>
          </div>
        </div>
        <div className=" flex flex-col gap-4 w-full">
          <div className=" flex justify-end w-full gap-4">
            <NavLink
              to={`/housing-societies/logs`}
              className="md:w-[8rem] w-max text-[#666666] bg-[#f3f3f3] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium"
            >
              Logs
            </NavLink>
            <button
              onClick={() => setOpen(true)}
              className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
            >
              Export Societies
            </button>
          </div>
          <div className=" flex justify-end w-full">
            <input
              type="search"
              placeholder="Search by name, location, or status..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
            />
          </div>
          {isLoading || isFetching ? (
            <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
              <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.8] rounded-xl"></div>
            </div>
          ) : (
            data && (
              <>
                {data?.totalPages === 0 ? (
                  <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                    No society Found
                  </div>
                ) : (
                  <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
                    {data?.societies?.map((society, i) => (
                      <div
                        key={society._id}
                        className={`${getBgColor(
                          society?.status,
                        )}  flex flex-col gap-1 rounded-xl lg:p-4 p-3 text-sm relative`}
                      >
                        <div className=" flex justify-between items-center gap-3">
                          <h1 className=" capitalize font-semibold text-[1rem] ">
                            {society?.name}
                          </h1>
                          <div className=" flex items-center gap-5">
                            <NavLink
                              to={`/housing-societies/timeLine/${society._id}`}
                            >
                              <ReactSVG
                                src={"/icon/timeline.svg"}
                                className={`w-5`}
                              />
                            </NavLink>

                            <NavLink
                              to={`/housing-societies/update-housing-societies/${society._id}`}
                            >
                              <HiDotsVertical className=" md:size-7 size-5 " />
                            </NavLink>
                          </div>
                        </div>
                        <span className="text-[#5F5F5F] font-medium">
                          Location:{" "}
                          <span className="font-normal">
                            {society?.location}
                          </span>
                        </span>
                        <span className="text-[#5F5F5F] font-medium">
                          Current Status:{" "}
                          <span className="font-normal capitalize">
                            {society?.status}
                          </span>
                        </span>
                        {society?.map?.mapUrl && (
                          <div className="flex  gap-3 font-semibold">
                            <ReactSVG
                              src={"/icon/location.svg"}
                              className={`w-3.5 fill-current ${gettextColor(
                                society?.status,
                              )}`}
                            />
                            <span
                              className={`flex underline ${gettextColor(
                                society?.status,
                              )} `}
                            >
                              <LOPLink
                                mapUrl={society.map.mapUrl}
                                status={society.status}
                              />
                              {society.map.mapUrl &&
                                society?.mortagedPlotsLink?.trim() &&
                                society?.mortagedPlotsLink?.trim() !== "" && (
                                  <span> / </span>
                                )}
                              {society?.mortagedPlotsLink?.trim() &&
                                society?.mortagedPlotsLink?.trim() !== "" && (
                                  <NavLink
                                    to={society?.mortagedPlotsLink}
                                    target="_blank"
                                  >
                                    Mortaged Plots
                                  </NavLink>
                                )}
                            </span>
                          </div>
                        )}
                        {society?.onePager?.docUrl && (
                          <button
                            type="button"
                            onClick={() =>
                              setViewFile({
                                url: society?.onePager?.docUrl,
                                mimeType: society?.onePager?.fileType,
                              })
                            }
                            className={`flex  gap-3 underline font-semibold ${gettextColor(
                              society?.status,
                            )}`}
                          >
                            <HiClipboardDocumentList className=" size-4" />
                            One Pager
                          </button>
                        )}
                        {/* <NavLink
                  className={`absolute z-[5] top-3 right-2`}
                  to={`/housing-societies/update-housing-societies/${society._id}`}
                >
                  <HiDotsVertical className="  size-7 " />
                </NavLink> */}
                      </div>
                    ))}
                  </div>
                )}
                <div className=" flex justify-between items-center">
                  <div className=" text-[#0000004f]">
                    Showing record page {data?.currentPage} 0f{" "}
                    {data?.totalPages}
                  </div>
                  <div className=" flex items-center gap-4">
                    <div
                      onClick={handlePrev}
                      disabled={page === 1}
                      className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                        page === 1
                          ? " cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                    >
                      <IoIosArrowBack className="size-6" />
                    </div>
                    {data?.currentPage}
                    <div
                      onClick={handleNext}
                      disabled={page === data?.totalPages}
                      className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                        page === data?.totalPages
                          ? " cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                    >
                      <IoIosArrowForward className="size-6" />
                    </div>
                  </div>
                </div>
              </>
            )
          )}
          {error && (
            <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
              {error?.data?.message}
            </p>
          )}{" "}
        </div>

        {viewFile && (
          <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
            <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] h-[95vh]  animate-fade-in text-black">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setViewFile(null);
                }}
                className="absolute top-4 right-4 text-[#00643b]"
                aria-label="Close modal"
              >
                <FiX className="size-6" />
              </button>
              <h2 className="text-[1.5rem] font-bold lg:mb-4 mb-3 text-[#00643b]">
                One Pager Doc
              </h2>
              {viewFile.mimeType === "application/pdf" ? (
                <iframe
                  src={viewFile.url}
                  width="100%"
                  height="90%"
                  className="rounded-[1rem] mt-2"
                  title="PDF Preview"
                />
              ) : viewFile.mimeType.startsWith("image/") ? (
                <img
                  src={viewFile.url}
                  alt="file Preview"
                  className="rounded-[1rem] mt-2 w-full h-[90%]  object-contain"
                />
              ) : (
                <p className="text-red-500 mt-4  text-center">
                  This file type cannot be previewed.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      <SocietiesPopUp open={open} setOpen={setOpen} />
    </>
  );
};

const SocietiesPopUp = ({ open, setOpen }) => {
  const [selectedStatus, setSelectedStatus] = useState("all");
  const societieStatus = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Approved",
      value: "approved",
    },
    {
      label: "Unapproved",
      value: "unapproved",
    },
    {
      label: "Under Process",
      value: "underProcess",
    },
    {
      label: "Illegal",
      value: "illegal",
    },
  ];
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      if (!selectedStatus) {
        toast.error("Please select the status first");
        return;
      }

      setIsExporting(true);

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/societies/exportSocieties?status=${selectedStatus}`,
        {
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement("a");
      a.href = url;
      a.download = `societies-${selectedStatus}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      setOpen(false);
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        const errorData = JSON.parse(text);

        showErrorToast(errorData);
      }
    } finally {
      setIsExporting(false);
    }
  };
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-[#FFFFFF05] backdrop-blur-sm backdrop-brightness-30 backdrop-opacity-60 z-[9999]">
      <div className=" w-[90%] mx-auto max-w-xl bg-white p-4 rounded-xl">
        <div className=" flex items-center justify-between gap-3">
          <h1 className="text-[#05004E] font-semibold lg:text-[1.4rem] md:text-[1.2rem] text-[1rem]">
            Export Societies
          </h1>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className=" text-[#05004E]"
          >
            <FiX className=" size-6" />
          </button>
        </div>
        <div className=" flex flex-col gap-3 py-4">
          <label
            htmlFor="societyStatus"
            className="text-[#05004E] font-semibold lg:text-[1.2rem] md:text-[1rem] text-[.8rem]"
          >
            Select the Societies Status
          </label>
          <div className=" flex flex-col gap-3">
            {societieStatus.map((status) => (
              <label
                key={status.value}
                className="flex items-center bg-white shadow-inner p-3 rounded-lg justify-between gap-2 cursor-pointer"
              >
                <span className="text-[#05004E]">{status.label}</span>
                <input
                  type="radio"
                  name="societyStatus"
                  id="societyStatus"
                  value={status.value}
                  checked={selectedStatus === status.value}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  className="accent-[#00643b]"
                />
              </label>
            ))}
          </div>
        </div>
        <div className=" flex items-center justify-end w-full">
          <button
            type="button"
            onClick={() => handleExport()}
            disabled={isExporting}
            className=" w-max bg-[#00643b] text-center disabled:cursor-not-allowed disabled:opacity-50 py-2 px-6 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            {isExporting ? "Exporting..." : "Export"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default HousingScocieties;
